<template>
  <div class="enroll-info-student">
    <PlatDataGridGrade grid-id="PeEnrollStudentInfo"
                       show-label></PlatDataGridGrade>
  </div>
</template>

<script>
import PlatDataGridGrade from '../../../wrapper/grid/PlatDataGridGrade'
export default {
  name: 'EnrollInfoStudent',
  components: {
    PlatDataGridGrade
  }
}
</script>

<style lang="scss">
  .enroll-info-student {
    height: 100%;
  }
</style>
